import React from "react"
import Helmet from "react-helmet"
import classNames from "classnames"

import { makeStyles } from "@material-ui/core/styles"
import Layout from "src/components/Layout"

import GlobalBaseState from "src/assets/js/GlobalBaseState.js"

// Sections for this page
import PrivacySection from "./Sections/PrivacySection"
import styles from "src/assets/jss/material-kit-react/views/privacyPage"

const useStyles = makeStyles(styles)

export default function PageMissingPage({ pageContent, ...rest }) {
  const pageClasses = useStyles()

  const [globalState, setGlobalState] = React.useState(GlobalBaseState)
  const [fullViewportIndex, setFullViewportIndex] = React.useState(null)

  const handleToggleFullViewport = propertyIndex => {
    setFullViewportIndex(fullViewportIndex === null ? propertyIndex : null)
  }

  return (
    <Layout
      pageClasses={pageClasses}
      scaffolding={pageContent.scaffolding}
      globalState={globalState}
      {...rest}
    >
      {(isLandscape /** isLandscape passed as method parameter */) => (
        <>
          <Helmet>
            <body
              className={classNames(pageClasses.body, "privacypage-wrapper")}
            />
          </Helmet>
          <PrivacySection
            pageContent={pageContent}
            siteVariables={rest.siteVariables}
            globalState={globalState}
          />
        </>
      )}
    </Layout>
  )
}
